import { PureComponent, ReactNode } from 'react';
import { Receipt } from '../../../../../api/getTreatmentPlan';
import { columnHeaderContent, headerStyle } from '../../../../common/TableUtils';
import moment from 'moment';
import { formattedNumber } from '../../../../../pages/utils';
import { Table } from 'antd';
import Column from 'antd/lib/table/Column';

interface Props {
    receipts: Receipt[];
}

class TreatmentPaymentsTable extends PureComponent<Props> {
    seqHeaderContent = columnHeaderContent('');
    dateHeaderContent = columnHeaderContent('Date');
    amountPaidHeaderContent = columnHeaderContent('Amount paid');
    paymentModeHeaderContent = columnHeaderContent('Payment mode');
    receiptIdHeaderContent = columnHeaderContent('Receipt ID');
    mrpHeaderContent = columnHeaderContent('Mrp');
    remarksHeaderContent = columnHeaderContent('Remarks');

    renderSeq = (_: Receipt, __: Receipt, index: number) => {
        return <p>{index + 1}</p>;
    };

    renderDate = (receipt: Receipt) => {
        const { created_at } = receipt;
        return <p>{moment(created_at).format("DD MMM'YY")}</p>;
    };

    renderAmountPaid = (receipt: Receipt) => {
        const { net_amount } = receipt;
        return <p>₹{formattedNumber(net_amount)}</p>;
    };

    renderPaymentMode = (receipt: Receipt) => {
        const { receipt_payment } = receipt;
        return (
            <p className="capitalize">
                {receipt_payment
                    ?.map((i) => i?.paymode?.replaceAll('_', ' ')?.toLowerCase())
                    ?.join(', ') || '-'}
            </p>
        );
    };

    renderReceiptId = (receipt: Receipt) => {
        const { receipt_id, receipt_url } = receipt;
        return (
            <p>
                <a
                    href={receipt_url}
                    target="_blank"
                    className="cursor-pointer text-darwin-accent-bright-blue-800"
                >
                    {receipt_id || '-'}
                </a>
            </p>
        );
    };

    renderMrp = (receipt: Receipt) => {
        const { receipt_sku } = receipt;
        return <p>₹{formattedNumber(receipt_sku?.reduce((acc, cur) => acc + cur.amount, 0))}</p>;
    };

    renderRemarks = (receipt: Receipt) => {
        const { remarks } = receipt;
        return <p>{remarks || '-'}</p>;
    };

    render(): ReactNode {
        const { receipts } = this.props;
        const showColumns: { [key: string]: boolean } = {};
        receipts?.forEach(({ remarks }) => {
            if (remarks) {
                showColumns['remarks'] = true;
            }
        });

        return (
            <Table
                dataSource={receipts}
                className="border-darwin-neutral_new-200"
                pagination={false}
                bordered
                style={{
                    borderWidth: '.5px',
                }}
            >
                <Column
                    title={this.seqHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-seq"
                    render={this.renderSeq}
                />
                <Column
                    title={this.dateHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-date"
                    render={this.renderDate}
                />
                <Column
                    title={this.amountPaidHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-amount-paid"
                    render={this.renderAmountPaid}
                />
                <Column
                    title={this.paymentModeHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-payment-mode"
                    render={this.renderPaymentMode}
                />
                <Column
                    title={this.receiptIdHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-receipt-id"
                    render={this.renderReceiptId}
                />
                <Column
                    title={this.mrpHeaderContent}
                    onHeaderCell={headerStyle}
                    key="treatment-payment-row-mrp"
                    render={this.renderMrp}
                />
                {showColumns['remarks'] && (
                    <Column
                        title={this.remarksHeaderContent}
                        onHeaderCell={headerStyle}
                        key="treatment-payment-row-remarks"
                        render={this.renderRemarks}
                    />
                )}
            </Table>
        );
    }
}

export default TreatmentPaymentsTable;
